import {Injectable, Injector} from '@angular/core';
import {KeyMap} from '@farris/ide-property-panel';
import {FlowFormInfo} from '../domain/entities/flowform-info';
import {VarEntity} from '@gsp-svc/expression';
import {GSPCommonModel} from '@gsp-bef/gsp-cm-metadata';
import {HttpService} from '@ecp-caf/caf-common';
import {forkJoin, Observable} from 'rxjs';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';
import { ProcessTime } from '../model/process-time';
import { BpmnModel } from '@edp-pmf/bpmn-model';
import { BsModalRef } from '@farris/ui-modal';

@Injectable()

export class ProcessDesignerUIState {
  scene: string;
  isByRoute: boolean;
  rootPath = '';
  constructor(
    private http: HttpService,
    private localePipe: WfLocalePipe
    ) {
    try {
      this.rootPath = (window as any).gspframeworkService.common.getBasePath.get();
    } catch (error) {
    }
  }

  // 入口单据Info
  flowFormInfo: FlowFormInfo = new FlowFormInfo();

  // Model上下文
  content = '';

  // 属性框
  propertyConfig: any[] = [];
  propertyData: any = {};

  // 设计器地址
  POST_MESSAGE_TARGET = window.document.location.origin + this.rootPath +'/platform/runtime/wf/web/designer/index.html';

  BE: GSPCommonModel;
  schemas: any[] = [];

  // 审批活动属性
  counterSignVariables: any[] = [];
  approvalItems: any[] = [];

  // 流程的审批活动节点信息
  userActList = [];
  // 流程包括结束和审批活动节点的信息
  allActList = [];
  // 流程包括审批活动，知会活动，消息的节点信息
  MessageActList = [];
  NotifyActKist = [];
  SubAndCatchActList = [];
  // 记录当前选中用户活动节点的bizActivityId
  bizActivityId: string;

  enableAdminOrgAut = false;
  enableFlowFormAut = false;

  procDefId: string;
  time: ProcessTime;

  // 流程管理员信息
  isAdministratorConfig = false;
  administrator: any;
  // organizations: any[] = new Array();
  startMode: string;

  //
  bpmnModel: BpmnModel;

  //表示另存为后的流程是否可以被保存成功
  isSaved: boolean = true;

  //表示表达式校验的那个弹框
  msg: BsModalRef;


  // 审批活动属性枚举===========================================================================================
  public assignIterator: KeyMap[] = [{key: 'ALL', value: this.localePipe.transform("app.processDesigner.all")},
    {key: 'ASSIGN', value: this.localePipe.transform("app.processDesigner.assign")},
    {key: 'CLAIM', value: this.localePipe.transform("app.processDesigner.claim")}];
  public completeIterator: KeyMap[] = [{key: 'Preempt', value: this.localePipe.transform("app.processDesigner.preempt")},
    {key: 'Parallel', value: this.localePipe.transform("app.processDesigner.parallel")},
    {key: 'Sequential', value: this.localePipe.transform("app.processDesigner.sequential")}];
  public completeIterator4Claim: KeyMap[] = [{key: 'Preempt', value: this.localePipe.transform("app.processDesigner.preempt")}];
  public boolIterator: KeyMap[] = [{key: true, value: this.localePipe.transform("app.processDesigner.true")},
    {key: false, value:  this.localePipe.transform("app.processDesigner.false")}];
  // 会签不允许跳转
  public noJump4Sign: KeyMap[] = [{key: false, value: this.localePipe.transform("app.processDesigner.false")}];
  // =================================================================================================

  // 流程实例上下文-----------------------------------------------
  procInstContext: VarEntity[] = [
    {key: 'dataId', name: this.localePipe.transform("app.processDesigner.dataId"), description: 'this.localePipe.transform("app.processDesigner.dataId")'},
    {key: 'procInstId', name: this.localePipe.transform("app.processDesigner.procInstId"), description: this.localePipe.transform("app.processDesigner.procInstId")},
    {key: 'bizDefKey', name: this.localePipe.transform("app.processDesigner.bizDefKey"), description: this.localePipe.transform("app.processDesigner.bizDefKey")},
    {key: 'processDefinitionKey', name: this.localePipe.transform("app.processDesigner.processDefinitionKey"), description: this.localePipe.transform("app.processDesigner.processDefinitionKey")},
    {key: 'procInstCreator', name: this.localePipe.transform("app.processDesigner.procInstCreator"), description: this.localePipe.transform("app.processDesigner.procInstCreator")},
    {key: 'businessCreator', name: this.localePipe.transform("app.processDesigner.businessCreator"), description: this.localePipe.transform("app.processDesigner.businessCreator")},
    {key: 'procInstDescription', name: this.localePipe.transform("app.processDesigner.procInstDescription"), description: this.localePipe.transform("app.processDesigner.procInstDescription")},
    {key: 'comment', name: this.localePipe.transform("app.processDesigner.comment"), description: this.localePipe.transform("app.processDesigner.comment") },
    {key: 'bizDefName', name: this.localePipe.transform("app.processDesigner.bizDefName"), description: this.localePipe.transform("app.processDesigner.bizDefName")},
    {key: 'curLoginUsername', name: this.localePipe.transform("app.processDesigner.curLoginUsername"), description: this.localePipe.transform("app.processDesigner.curLoginUsername")},
    {key: 'procInstCreatorName', name: this.localePipe.transform("app.processDesigner.procInstCreatorName"), description: this.localePipe.transform("app.processDesigner.procInstCreatorName") },
    {key: 'currentParticipantId', name: this.localePipe.transform("app.processDesigner.currentParticipantId"), description: this.localePipe.transform("app.processDesigner.currentParticipantId")},
    {key: 'currentParticipantName', name: this.localePipe.transform("app.processDesigner.currentParticipantName"), description: this.localePipe.transform("app.processDesigner.currentParticipantName")}
  ];

  // 催办上下文--------------------------------------------------
  urgeContext: VarEntity[] = [
    {key: 'dataId', name: this.localePipe.transform("app.processDesigner.dataId"), description: this.localePipe.transform("app.processDesigner.dataId")},
    {key: 'procInstId', name: this.localePipe.transform("app.processDesigner.procInstId"), description: this.localePipe.transform("app.processDesigner.procInstId")},
    {key: 'bizDefKey', name: this.localePipe.transform("app.processDesigner.bizDefKey"), description: this.localePipe.transform("app.processDesigner.bizDefKey")},
    {key: 'processDefinitionKey', name: this.localePipe.transform("app.processDesigner.processDefinitionKey"), description: this.localePipe.transform("app.processDesigner.processDefinitionKey")},
    {key: 'procInstCreator', name: this.localePipe.transform("app.processDesigner.procInstCreator"), description: this.localePipe.transform("app.processDesigner.procInstCreator")},
    {key: 'businessCreator', name: this.localePipe.transform("app.processDesigner.businessCreator"), description: this.localePipe.transform("app.processDesigner.businessCreator")},
    {key: 'procInstDescription', name: this.localePipe.transform("app.processDesigner.procInstDescription"), description: this.localePipe.transform("app.processDesigner.procInstDescription")},
    {key: 'comment', name: this.localePipe.transform("app.processDesigner.comment"), description: this.localePipe.transform("app.processDesigner.comment")},
    {key: 'bizDefName', name: this.localePipe.transform("app.processDesigner.bizDefName"), description: this.localePipe.transform("app.processDesigner.bizDefName")},
    {key: 'curLoginUsername', name: this.localePipe.transform("app.processDesigner.curLoginUsername"), description:this.localePipe.transform("app.processDesigner.curLoginUsername")},
    {key: 'procInstCreatorName', name: this.localePipe.transform("app.processDesigner.procInstCreatorName"), description: this.localePipe.transform("app.processDesigner.procInstCreatorName")}
  ];
  /**
   * 流程参数上下文
   */
  formalParameterContext: VarEntity[] = [];

  /**
   * 参与者上下文
   */
  participantContext: VarEntity[] = [
    {
      key: 'procInstCreator',
      name: this.localePipe.transform("app.processDesigner.procInstCreator"),
      description: this.localePipe.transform("app.processDesigner.procInstCreator")
    }, {
      key: 'businessCreator',
      name: this.localePipe.transform("app.processDesigner.businessCreator"),
      description: this.localePipe.transform("app.processDesigner.businessCreator")
    }, {
      key: 'currentUser',
      name: this.localePipe.transform("app.processDesigner.currentUser"),
      description: this.localePipe.transform("app.processDesigner.currentUser")
    }, {
      key: 'preActExecutors',
      name: this.localePipe.transform("app.processDesigner.preActExecutors"),
      description: this.localePipe.transform("app.processDesigner.preActExecutors")
    }];

    /**
   * 子活动上下文
   */
  subActivityContext: VarEntity[] = [
    {
      key: 'collectionElementVariable',
      name: this.localePipe.transform("app.processDesigner.collectionElementVariable"),
      description: this.localePipe.transform("app.processDesigner.collectionElementVariable")
    }];

    /**
   * 子流程元素上下文
   */
  subProcessElementContext: VarEntity[] = [
    {
      key: 'subCollectionElementVariable',
      name: this.localePipe.transform("app.processDesigner.subCollectionElementVariable"),
      description: this.localePipe.transform("app.processDesigner.subCollectionElementVariable")
    }];

  /**
   * 多实例启用条件上下文
   */
  multiCounterSignVariables: VarEntity[] = [
    {key: 'nrOfInstances', name: this.localePipe.transform("app.processDesigner.nrOfInstances"), description: this.localePipe.transform("app.processDesigner.nrOfInstances")},
    {key: 'nrOfCompletedInstances', name: this.localePipe.transform("app.processDesigner.nrOfCompletedInstances"), description: this.localePipe.transform("app.processDesigner.nrOfCompletedInstances")},
    {key: 'nrOfActiveInstances', name: this.localePipe.transform("app.processDesigner.nrOfActiveInstances"), description: this.localePipe.transform("app.processDesigner.nrOfActiveInstances")},
    {key: 'nrOfForward', name: this.localePipe.transform("app.processDesigner.nrOfForward"), description: this.localePipe.transform("app.processDesigner.nrOfForward")},
    {key: 'nrOfBackward', name: this.localePipe.transform("app.processDesigner.nrOfBackward"), description: this.localePipe.transform("app.processDesigner.nrOfBackward")},
    {key: 'nrOfAbort', name: this.localePipe.transform("app.processDesigner.nrOfAbort"), description: this.localePipe.transform("app.processDesigner.nrOfAbort")}
    ];

  /**
   * 活动构件参数上下文
   */
  activityComponentContext: VarEntity[] = [
    {
      key: 'conclusionType',
      name: this.localePipe.transform("app.processDesigner.conclusionType"),
      description: this.localePipe.transform("app.processDesigner.conclusionTypeTips")
    }, {
      key: 'conclusionValue',
      name: this.localePipe.transform("app.processDesigner.conclusionValue"),
      description: this.localePipe.transform("app.processDesigner.conclusionValueTips")
    }];
  processVariableContext: VarEntity[] = new Array();

  private processVariables = new Array();

  set ProcessVariables(variables: any[]) {
    this.processVariables = variables;
    this.setProcessVariableContext();
  }

  get ProcessVariables() {
    return this.processVariables;
  }

  /**
   * 汇报级次
   */
  dimensions = [
    {value: 'directSuperior', text: this.localePipe.transform("app.processDesigner.directSuperior")},
    {value: 'higherSuperior', text: this.localePipe.transform("app.processDesigner.higherSuperior")}
  ];

  /**
   * 启动方式
   */
  startModeIterator: KeyMap[] = [
    {key: 'DIRECT', value: this.localePipe.transform("app.processDesigner.DIRECT")},
    {key: 'EXTERNAL_PROCESS', value: this.localePipe.transform("app.processDesigner.EXTERNAL_PROCESS")},
    {key: 'SUB_PROCESS', value: this.localePipe.transform("app.processDesigner.SUB_PROCESS")}
  ];

  /**
   * 显示终端
   */
  displayTerminal: KeyMap[] = [
    {key: "ALL", value: this.localePipe.transform("app.processDesigner.ALL")},
    {key: "WEB", value: this.localePipe.transform("app.processDesigner.WEB")},
    {key: "APP", value: this.localePipe.transform("app.processDesigner.APP")}
  ];

  /**
   * 消息渠道列表
   */
  messageChannels = new Array();

  orgTypeCollection: { value, text }[] = [];

  variableContextName(key: string) {
    return this.participantContext.find(i => i.key === key).name;
  }

  ranksName(value: string) {
    return this.dimensions.find(i => i.value === value).text;
  }

  getMessageChannels() {
    const url = '/api/runtime/msg/v1.0/messageplatform/channel/getenabledchannels';
    this.http.get(url).subscribe((re: any) => {
      this.messageChannels = re;
    });
  }

  getAdministratorInfo() {
    this.getCurrentUser().subscribe(user => {
      const userId = user.userId;
      forkJoin(this.getAdministratorConfig(), this.getAdministrator(userId)).subscribe(re => {
        this.isAdministratorConfig = re[0].currentValue === 'true' ? true : false;
        this.administrator = re[1];
      });
    });
  }

  getEnableAdminOrgAut(): Observable<any> {
    return this.getEnableProcessDesignerDataAut('WF_AdminOrg');
  }

  getEnableFlowFormAut(): Observable<any> {
      return this.getEnableProcessDesignerDataAut('WF_FlowForm');
  }

  private getEnableProcessDesignerDataAut(authField: string): Observable<any> {
    const url = '/api/runtime/wf/v1.0/dtProcDefs/enableProcessDesignerDataAut/' + authField;
    return this.http.get(url);
  }

  private getCurrentUser(): Observable<any> {
    const url = '/api/runtime/sys/v1.0/userinfos?infoType=user';
    return this.http.get(url);
  }

  private getAdministrator(userId: string): Observable<any> {
    const url = `/api/runtime/wf/v1.0/processAdministrator/${userId}`;
    return this.http.get(url);
  }

  public getReleaseConfig(): Observable<any> {
    const url = `/api/runtime/wf/v1.0/generalConfig/Is_Enable_Examine`;
    return this.http.get(url);
  }
  private getAdministratorConfig(): Observable<any> {
    const url = `/api/runtime/wf/v1.0/generalConfig/Is_EnableAdministrator`;
    return this.http.get(url);
  }
  private getSysOrgById(orgId: string): Observable<any> {
    const url = `/api/runtime/sys/v1.0/sysOrgs/${orgId}`;
    return this.http.get(url);
  }

  private getSysOrgWithAllSubsById(orgId: string): Observable<any> {
    const url = `/api/runtime/sys/v1.0/sysOrgs?param=` + encodeURIComponent(`{"parentId":"${orgId}","withAllSub":true}`);
    return this.http.get(url);
  }

  private getCurUserInfo(userId: string): Observable<any> {
    const url = `/api/runtime/sys/v1.0/users/${userId}`;
    return this.http.get(url);
  }

  getOrgConfig(): Observable<any> {
    const url = `/api/runtime/wf/v1.0/generalConfig/Is_Required_Organization`;
    return this.http.get(url);
  }
  /**
   * 获取当前用户信息
   */
  getUserInfo(): Observable<any> {
    const url = `/api/runtime/sys/v1.0/userinfos?infoType=user`;
    return this.http.get(url);
  }
  /**
   * 流程审核：新增
   */
  createData(): Observable<any> {
    const url = `/api/bpms/wf/v1.0/processrelease_frm`;
    const requestInfo = {
      dataChange: [],
      variableChange: null
    };
    return this.http.post(url, requestInfo);
  }
  /**
   * 流程审核：保存
   */
  releaseSave(data: any): Observable<any> {
    const requestInfo = {
      dataChange: [data],
      variableChange: null
    };
    const url = `/api/bpms/wf/v1.0/processrelease_frm`;
    return this.http.put(url, requestInfo);
  }
  private setProcessVariableContext() {
    this.processVariableContext = new Array();
    if (this.ProcessVariables && this.ProcessVariables.length > 0) {
      for (const v of this.ProcessVariables) {
        const varEntity = {
          key: v.name,
          name: v.documentation,
          description: v.description
        };
        this.processVariableContext.push(varEntity);
      }
    }
  }


  getHelpMetaData(helpId: string, su: string): Observable<any> {
    const url = `/api/runtime/lcm/v1.0/rt-metadatas/${helpId}`;
    return this.http.get(url);
  }

  /**
   * 获取框架的顶级window
   * 进行跨域封装
   */
  private getTopWindow(): Window {
    let curWin: Window = window.self;
    try {
        while (curWin.location.origin === curWin.parent.location.origin) {
            if (curWin !== curWin.parent && !(curWin as any).isRTFTopWin) {
                curWin = curWin.parent;
            } else {
                break;
            }
        }
    } catch (e) { }
    return curWin;
  }

  // --------------------------0-------------------------

  // uiState初始
  initUIState() {
    this.propertyConfig = [];
    this.propertyData = null;
    this.content = '';
    this.schemas = [];
  }

  /**
   * 获取所有审批节点信息
   * @param data
   */
  getUserActList(data: any[]) {
    this.userActList = [];
    if (data && data.length > 0) {
      for (const userAct of data) {
        const userActInfo: any = {
          Id: userAct.Id,
          Name: userAct.NameLanguage ? (userAct.NameLanguage[this.localePipe.langCode] ? userAct.NameLanguage[this.localePipe.langCode] : userAct.Name) : userAct.Name,
          ClrTypeID: userAct.ClrTypeID,
          AssignmentStrategy: userAct.AssignmentStrategy
        };
        if (userAct.AssignmentStrategy === 'ASSIGN') {
          userActInfo.AssignPerformerConfig = userAct.AssignPerformerConfig;
        }
        this.userActList.push(userActInfo);
      }
    }
  }

  /**
   * 获取所有结束节点信息
   * @param data
   */
     getEndEventList(data: any[]) {
      this.allActList = [];
      if (data && data.length > 0) {
        for (const endEvent of data) {
          const endEventInfo = {
            Id: endEvent.Id,
            Name: endEvent.NameLanguage ? (endEvent.NameLanguage[this.localePipe.langCode] ? endEvent.NameLanguage[this.localePipe.langCode] : endEvent.Name) : endEvent.Name
          };
          // 取结束节点存到
          this.allActList.push(endEventInfo);
        }
      }
      // // 存入审批活动节点
      // this.allActList = this.allActList.concat(this.userActList);
    }

  /**
   * 获取所有知会活动节点信息
   * @param data
   */
   getNotifyEventList(data: any[]) {
    this.NotifyActKist = [];
    if (data && data.length > 0) {
      for (const notifyEvent of data) {
        const notifyEventInfo = {
          Id: notifyEvent.Id,
          Name: notifyEvent.Name
        };
        // 取知会活动，消息节点存到
        this.NotifyActKist.push(notifyEventInfo);
      }
    }
  }
  //TODO: 只有审批\审批+人工\审批+人工+知会\审批、人工、子流程、信号捕获
  /**
   * 获取所有消息节点信息
   * @param data
   */
   getMessageEventList(data: any[]) {
    this.MessageActList = [];
    if (data && data.length > 0) {
      for (const messageEvent of data) {
        const messageEventInfo = {
          Id: messageEvent.Id,
          Name: messageEvent.Name
        };
        // 取知会活动，消息节点存到
        this.MessageActList.push(messageEventInfo);
      }
    }
    // 存入审批活动节点
    this.MessageActList = this.MessageActList.concat(this.NotifyActKist);
    // 存入审批活动节点
    this.MessageActList = this.MessageActList.concat(this.userActList);
  }
  /**
   * @param data
   */
  getSubAndCatchEventsList(data: any[]) {
    this.SubAndCatchActList = [];
    if (data && data.length > 0) {
      for (const subAndCatchEvent of data) {
        const subAndCatEventInfo = {
          Id: subAndCatchEvent.Id,
          Name: subAndCatchEvent.Name
        };
        // 取知会活动，消息节点存到
        this.SubAndCatchActList.push(subAndCatEventInfo);
      }
    }
  }

  /**
   * 获取当前流程启动方式
   * @param data
   */
  getStartMode(data: any) {
    this.startMode = data;
  }

  /**
   * 添加上下文变量
   */
  addContext(context: any[]) {
    if (this.procInstContext.length > 0) {
      for (const variable of this.procInstContext) {
        context.push(variable);
      }
    }
    if (this.formalParameterContext.length > 0) {
      for (const variable of this.formalParameterContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.participantContext.length > 0) {
      for (const variable of this.participantContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.processVariableContext.length > 0) {
      for (const variable of this.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    return context;
  }

  /**
   * 创建内码
   */
  createNM() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }
  
}


